import React from 'react';
import Modal from 'react-bootstrap/Modal';
import withTranslations from '../../utils/HighOrderComponent';
import ComplementSignetTableHistory from './ProcessingView/ComplementSignetTableHistory';

class ModalForViewComplementSignetHistory extends React.Component {
  handleClose = () => {
    this.props.handleClose();
  };

  render() {
    const { t, complementSignetList } = this.props || {},
      { Labels } = t || {};

    return (
      <Modal
        show={this.props.show}
        onHide={this.handleClose}
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="wide-modal second-modal"
      >
        <Modal.Header closeButton>
          <Modal.Body>
            <h5 className="title">{Labels.title}</h5>
            <form>
              <div className="row">
                <div className="col-md-12 mb-3">
                  <ComplementSignetTableHistory
                    complementSignetList={complementSignetList}
                  />
                </div>
              </div>
            </form>
          </Modal.Body>
        </Modal.Header>
      </Modal>
    );
  }
}

export default withTranslations(
  ModalForViewComplementSignetHistory,
  'ModalForViewComplementSignetHistory'
);
